// extracted by mini-css-extract-plugin
module.exports = {"appearDelayed":"Button_appearDelayed__3JY8Z","fadeIn":"Button_fadeIn__2nzfC"};